<div class="modal-header">
    <h5 class="pt-4 ps-4">Editar Grupo - {{nombreGrupo}}</h5>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>
<mat-dialog-content class="mat-typography">
    <form autocomplete="off" [formGroup]="formCampaign" (ngSubmit)="ruSure()" class="mt-3" id="userForm">
        <div class="row mt-2">
            <div class="col-sm-12">
                <mat-form-field class="w-100" color="accent">
                    <mat-label>Capturas</mat-label>
                    <input matInput formControlName="capturas" type="number">
                </mat-form-field>
                
                <mat-form-field class="w-100" color="accent">
                    <mat-label>Orientacion </mat-label>
                    <mat-select formControlName="orientacion">
                        <mat-option [value]="1">Horizontal</mat-option>
                        <mat-option [value]="2">Vertical</mat-option>
                    </mat-select>
                </mat-form-field>                
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button class="bg-success text-white" form="userForm" type="submit">Guardar <mat-icon>save</mat-icon></button>
</mat-dialog-actions>